import { tbContainer } from "./tbContainer";
import { PIXI } from "./tbPIXI";
export var tbParticle = function (container, particleJSON, images, trail) {
    "use strict";
    this.baseContainer = new tbContainer();
    container.addChild(this.baseContainer);
    this.container = container.container;
    this.particleJSON = JSON.parse(JSON.stringify(particleJSON));
    this.emitter = undefined;
    this.images = images;
    this.looping = true;
    this.callback = null;
    this.isAlive = false;
    this.rotation = 0;
    this.scale = 1;
    this.isTrail = (trail === undefined) ? false : true;
    this.x = 0;
    this.y = 0;
    this.init();
};
tbParticle.prototype.init = function () {
    "use strict";
    var _images = [];
    for (var i = 0; i < this.images.length; i++) {
        _images.push(this.images[i].getFrame().texture);
    }
    this.emitter = new PIXI["particles"]["Emitter"](this.baseContainer.container, _images, this.particleJSON);
    this.x = this.emitter["spawnPos"]["x"];
    this.y = this.emitter["spawnPos"]["y"];
    this.rotation = this.emitter["rotation"];
    if (this.emitter["emitterLifetime"] > 0) {
        this.looping = false;
    }
};
tbParticle.prototype.show = function () {
    "use strict";
    this.emitter["emit"] = true;
    this.isAlive = true;
};
tbParticle.prototype.hide = function () {
    "use strict";
    this.emitter["emit"] = false;
    this.isAlive = false;
};
tbParticle.prototype.reset = function () {
    "use strict";
    this.emitter["emit"] = true;
    this.isAlive = true;
    this.emitter["_emitterLife"] = 0;
};
tbParticle.prototype.update = function (timePassed) {
    "use strict";
    if (!this.isAlive) {
        return;
    }
    var secondsPassed = timePassed / 1000;
    this.emitter["update"](secondsPassed);
    if (!this.looping && this.emitter["particleCount"] === 0 && this.callback) {
        this.callback();
        this.destroy();
        this.isAlive = false;
    }
};
tbParticle.prototype.setPosition = function (x, y) {
    "use strict";
    this.x = x;
    this.y = y;
    if (this.isTrail) {
        this.emitter["updateSpawnPos"](x, y);
    }
    else {
        this.baseContainer.setPosition(x, y);
    }
};
tbParticle.prototype.setMove = function (x, y) {
    "use strict";
    if (this.isTrail) {
        this.emitter["updateSpawnPos"](x, y);
    }
};
tbParticle.prototype.setCallback = function (call) {
    "use strict";
    this.callback = call;
};
tbParticle.prototype.destroy = function () {
    "use strict";
    this.emitter["destroy"]();
    this.container.removeChild(this.baseContainer);
};
tbParticle.prototype.setRotation = function (r) {
    "use strict";
    this.rotation = r;
    this.emitter["rotate"](r);
};
tbParticle.prototype.setScale = function (s) {
    "use strict";
    this.scale = s;
    if (this.isTrail) {
        this.emitter["startScale"] *= this.scale;
        this.emitter["endScale"] *= this.scale;
    }
    else {
        this.baseContainer.setScale(this.scale, this.scale);
    }
};
